import React from "react";
import { Link } from "react-router-dom";
function SpringHouse() {
  return (
    <>
      <div className="our-approch">
        <div className="container">
          <div className="breadcrumb-container">
            <ul className="breadcrumbs">
              <li>
                <Link
                  to="/"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Home /
                </Link>

                <Link
                  to="/ourhome"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Our Home
                </Link>
              </li>
              <li>Spring House</li>
            </ul>
          </div>

          <h2 className="banner-heading">Spring House</h2>
        </div>
      </div>
    </>
  );
}

export default SpringHouse;
